// TripScheduleFromURL.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import TripSchedule from './index';
import { getCompanyServicetax, getHasServiceTax, getSeatChart, getSubRoutesCity, getTridDetailsByTripId } from '../../../../redux/Actions';
import moment from 'moment';

const TripScheduleFromURL = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [chartData, setChartData] = useState(null);
    const [trip, setTrip] = useState(null);
    // Extract and parse query params with full variable names
    const userId = parseInt(searchParams.get('uid'), 10) || 0;
    const tripId = parseInt(searchParams.get('tid'), 10) || 0;
    const fromCityId = parseInt(searchParams.get('fci'), 10) || 0;
    const toCityId = parseInt(searchParams.get('tci'), 10) || 0;
    const journeyDate = searchParams.get('jd') || '';
    const chartDate = searchParams.get('cd') || '';
    const companyId = searchParams.get('cid') || '';
    const IsQuotaBranch = searchParams.get('Isqb') || '';
    const tokenPassword = searchParams.get('tknpswd') || '';
    const companyName = searchParams.get('cn') || '';
    useEffect(() => {
        const body = {
            userID: userId,
            tripID: tripId,
            userMode: 'U',
            fromCityID: fromCityId,
            toCityID: toCityId,
            chartDate: moment(chartDate, 'DD-MMM-YYYY').format("YYYY-MM-DD")
        }
        dispatch(getSeatChart(body)).then((res) => {
            if (res?.status === 200) {
                setChartData(res?.data?.APIGetChartLayoutWithFareV3Result)
            } else {
                setChartData({})
            }
        })
        const bodyTrip = {
            intTripID: tripId,
            intUserID: userId,
            dtJDate: journeyDate,
            intCompanyID: companyId,
            strEntityType: "U",//default
            blnIsQuotaBranch: IsQuotaBranch || false,
            intBranchID: 0,//default
        }
        dispatch(getTridDetailsByTripId(bodyTrip)).then((res) => {
            if (res?.status === 200) {
                setTrip(res?.data?.MavenTripDetailsResult?.MavenTripDetails[0] || {})
            } else {
                setTrip({})
            }
        })
        const body1 = {
            intTripID: tripId,
            dtChartDate: moment(chartDate, 'DD-MMM-YYYY').format("YYYY-MM-DD")
        }
        dispatch(getSubRoutesCity(body1))
    }, [])
    const handleBack = () => {
        const newParams = new URLSearchParams(searchParams.toString());
        newParams.set('isBack', 'true'); // add or update the flag
        navigate(`?${newParams.toString()}`);
    };
    const callServiceTax = (fromCityID, toCityID) => {

        const hasTaxBody = {
            intTripID: tripId,
            intFromCityID: fromCityID,
            intToCityID: toCityID,
            dtJdate: moment(journeyDate, 'DD-MMM-YYYY').format("YYYY-MM-DD")
        }
        dispatch(getHasServiceTax(hasTaxBody)).then((taxRes) => {
            if (taxRes?.status === 200) {
                if (Number(taxRes.data.HasServiceTaxResult) === 1) {
                    dispatch(getCompanyServicetax({ intTripID: tripId })).then((res) => {
                        if (res?.status === 200) {

                        }
                        callChartApi(fromCityID, toCityID)
                    })
                } else {
                    callChartApi(fromCityID, toCityID)
                }
            }
        })
    }
    const callChartApi = (fromCityID, toCityID) => {
        setChartData({})
        const body = {
            userID: userId,
            tripID: tripId,
            userMode: 'U',
            fromCityID: fromCityID,
            toCityID: toCityID,
            chartDate: moment(chartData, 'DD-MMM-YYYY').format("YYYY-MM-DD")
        }
        dispatch(getSeatChart(body)).then((res) => {
            if (res?.status === 200) {
                setChartData(res?.data?.APIGetChartLayoutWithFareV3Result)
            } else {
                setChartData({})
            }
        })
    }
    return (
        <>
            {trip && chartData ? (
                <TripSchedule
                    // trip={{ JourneyDate: journeyDate, ChartDate: chartDate, TripID: tripId }}
                    trip={trip}
                    chartData={chartData}
                    onBack={handleBack}
                    handleAfterBooking={() => {
                        callServiceTax(fromCityId, toCityId)
                    }
                    }
                    userDetails={{ UserID: userId, CompanyID: companyId, TokenPassword: tokenPassword, CompanyName: companyName }}
                />
            ) : (
                null
            )}

        </>
    );
};

export default TripScheduleFromURL;
